import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ProjectsTableComponent } from '../projects-table/projects-table.component';

@Component({
  selector: 'place-projects',
  templateUrl: '../projects-table/projects-table.component.html',
  styleUrls: ['../projects-table/projects-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlaceProjectsComponent extends ProjectsTableComponent {
  ngOnInit() {
    super.ngOnInit();
    this.projects = [];
    this.displayedColumns = [
      'project_id',
      'currentRequestDate',
      'currentConfirmedPlacementDate',
      'company',
      'projectPlacement.address',
      'productType',
      'productSize',
      'placer',
      'locationVerified',
      'displayStatus',
      'star'
    ];
  }

  protected getLocalStorageKey(): string {
    return 'PlaceProjectsComponent';
  }

  protected getStatusFilter(): string {
    return 'statusSubstatus/In_behandeling/Te_plaatsen';
  }

  public getPageTitle(): string {
    return 'Te plaatsen';
  }

  // Override
  public getDefaultSort() {
    return 'currentConfirmedPlacementDate';
  }
}
